var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "../../themes/styled";
import { ifProp } from "styled-tools";
import Text from "../../text/Text";
var StyledLabel = styled("div")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    box-sizing: border-box;\n    position: absolute;\n    width: 100%;\n    z-index: 1;\n    top: ", ";\n    padding-left: 11px;\n    transition: 0.2s;\n    user-select: none;\n"], ["\n    box-sizing: border-box;\n    position: absolute;\n    width: 100%;\n    z-index: 1;\n    top: ", ";\n    padding-left: 11px;\n    transition: 0.2s;\n    user-select: none;\n"])), ifProp("doShrink", "7px", "22px"));
var FloatLabel = function (_a) {
    var doShrink = _a.doShrink, children = _a.children, rest = __rest(_a, ["doShrink", "children"]);
    return (React.createElement(StyledLabel, { doShrink: doShrink },
        React.createElement("label", __assign({}, rest),
            React.createElement(Text, { fontSize: doShrink ? "14px" : 2, color: "grays.4", style: { transition: "0.2s" } }, children))));
};
export default FloatLabel;
var templateObject_1;
//# sourceMappingURL=FloatLabel.js.map